/*eslint-disable*/
import { useGet, usePut, usePost } from "./useRequest";
export function loadDraftApplications(page = 0, pageSize = 10) {
  const path = `/Candidates/current/DraftApplicationSummaries?page=${page}&size=${pageSize}`;
  return useGet(path);
}

export function getExistingApplication(jobid) {
  const path = `/DraftApplications/${jobid}/initialise`;
  return useGet(path);
}

export function saveDraftApplication(draft) {
  const path = `/DraftApplications/${draft.id}`;
  return usePut(path, draft);
}

export function addDraftApplication(draft) {
  const path = `/Candidates/current/DraftApplications`;
  return usePost(path, draft);
}
